import { toSentenceCase } from '@omnipresentgroup/helpers';
import { ExpenseCategoryEnum } from '@omnipresentgroup/types';

export const ExpenseCategory = ({
  category,
}: {
  category: ExpenseCategoryEnum;
}) =>
  Object.values(ExpenseCategoryEnum).includes(category)
    ? toSentenceCase(category)
    : '';
